import { PaymentClient } from "@src/apis/ModularClient";

export class ManageLicenseController {
  isCancelClicked: boolean = false;

  static $inject = ["$scope", "$rootScope", "$cookies", "$location", "PaymentClient"];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private paymentClient: PaymentClient,
  ) {}

  //TODO: needs putting back
  // updatePrice() {
  //   this.paymentClient.updatePlanPrice().then((response) => {});
  // }

  cancelSubscription() {
    this.paymentClient.cancelSubscription("").then((response) => {
      this.isCancelClicked = true;
    });
  }

  gotoProfilePage() {
    this.$location.path("/profile");
  }
}
